import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/Logo";
import { Input } from "@/components/ui/input";
import { LogIn, Lock } from "lucide-react";

function formatApiErrorDetail(detail) {
  if (detail == null) return "Une erreur est survenue.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return String(detail);
}

const BG = "/img/admin-bg.jpg";

export default function Login() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="flex items-center justify-center p-6 bg-white">
        <div className="w-full max-w-sm">
          <Logo />
          <h1 className="font-head text-3xl font-extrabold text-[#1a2d56] mt-10">Espace équipe</h1>
          <p className="text-[#4b5b7c] mt-2">Connectez-vous pour accéder au Restart Engine.</p>

          <form onSubmit={submit} className="mt-8 space-y-4" data-testid="login-form">
            <div>
              <label className="text-sm font-semibold text-[#1a2d56] mb-1.5 block">Email</label>
              <Input data-testid="login-email" type="email" value={email}
                onChange={(e) => setEmail(e.target.value)} placeholder="sante@bhealth.be"
                className="rounded-xl py-6" />
            </div>
            <div>
              <label className="text-sm font-semibold text-[#1a2d56] mb-1.5 block">Mot de passe</label>
              <Input data-testid="login-password" type="password" value={password}
                onChange={(e) => setPassword(e.target.value)} placeholder="••••••••"
                className="rounded-xl py-6" />
            </div>
            {error && <p className="text-sm text-rose-600" data-testid="login-error">{error}</p>}
            <button
              data-testid="login-submit"
              disabled={loading}
              className="w-full inline-flex items-center justify-center gap-2 bg-[#1a2d56] text-white font-head font-bold rounded-full px-8 py-4 hover:bg-[#1a2d56]/90 transition-colors disabled:opacity-60"
            >
              <LogIn size={18} /> {loading ? "Connexion…" : "Se connecter"}
            </button>
          </form>
          <button onClick={() => navigate("/")} className="mt-6 text-sm text-[#4b5b7c] hover:text-[#1a2d56]">
            ← Retour au site
          </button>
        </div>
      </div>
      <div className="hidden lg:block relative">
        <img src={BG} alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-[#1a2d56]/70" />
        <div className="absolute bottom-12 left-12 right-12 text-white">
          <Lock size={28} className="text-[#d7de3b]" />
          <p className="font-head text-2xl font-bold mt-4">B.health Restart Engine</p>
          <p className="text-white/70 mt-2">Génération, qualification et suivi de vos leads.</p>
        </div>
      </div>
    </div>
  );
}
